import { lmMenus, WPAPIEndpoint } from '@/globalVariables';
import { lmLength } from '../helpers';

const lmGetNavMenu: () => Promise<Record<string, any>> = async (): Promise<Record<string, any>> => {
    if ( lmLength( lmMenus ) ) {
        return lmMenus;
    } else {
        try {
            const menusAllEndpoint: string = `${WPAPIEndpoint}/menu/`;
            if ( window.lmEnv !== 'prod' ) {
                console.log( 'lmGetNavMenu ' + menusAllEndpoint );
            }
            const response: Response = await fetch( menusAllEndpoint );
            if ( ! response.ok ) {
                throw new Error( `HTTP error! Status: ${response.status}` );
            }
            const data: Record<string, any> = await response.json();
            for ( let menuLocation in data ) {
                lmMenus[ menuLocation ] = data[ menuLocation ];
            }
            return lmMenus;
        } catch ( error ) {
            console.log( 'Error fetching nav menus: ' + error );
            throw error;
        }
    }
}
export default lmGetNavMenu;